import { Link } from 'react-router-dom';
import { nbaVideos } from '@/mocks/homeData';

export default function NbaSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Split layout */}
        <div className="flex flex-col lg:flex-row gap-0 rounded-2xl overflow-hidden">
          {/* Left - Image */}
          <div className="lg:w-1/2 relative min-h-[280px] md:min-h-[380px]">
            <img
              src="https://readdy.ai/api/search-image?query=NBA%20basketball%20intense%20game%20action%20dunk%20moment%20dramatic%20arena%20lighting%20professional%20sports%20photography%20dark%20moody%20atmosphere%20championship%20moment%20epic%20composition&width=960&height=760&seq=nba-hero-section&orientation=landscape"
              alt="NBA赛事专区"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            {/* Overlay label */}
            <div className="absolute top-4 left-4 px-3 py-1.5 rounded-lg bg-black/50 backdrop-blur-sm text-white text-xs font-medium">
              NBA 赛事专区
            </div>
            <div className="absolute bottom-4 left-4">
              <h3 className="text-white font-heading font-bold text-xl md:text-2xl leading-tight">
                精彩赛事
              </h3>
              <h3 className="text-white font-heading font-bold text-xl md:text-2xl leading-tight">
                永久免费观看
              </h3>
            </div>
          </div>

          {/* Right - Video list */}
          <div className="lg:w-1/2 bg-background-100 p-5 md:p-8 flex flex-col justify-center">
            <div className="mb-4">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-1">
                NBA 赛事视频
              </h2>
              <p className="text-foreground-500 text-xs md:text-sm">
                同步更新最新NBA赛事集锦与全场回放，永久免费在线观看
              </p>
            </div>

            <div className="space-y-3">
              {nbaVideos.slice(0, 4).map((video) => (
                <Link
                  key={video.id}
                  to={`/article/${video.id}`}
                  className="flex items-center gap-3 p-3 rounded-xl hover:bg-background-200/60 transition-colors duration-200 cursor-pointer group"
                >
                  {/* Thumbnail */}
                  <div className="w-28 md:w-32 h-18 md:h-20 rounded-lg overflow-hidden bg-background-300 flex-shrink-0">
                    <img
                      src={video.cover}
                      alt={video.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  {/* Info */}
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-1.5">
                      {video.title}
                    </h4>
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {video.views}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {video.duration}
                      </span>
                      <span>{video.date}</span>
                    </div>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200 flex-shrink-0">
                    <i className="ri-play-fill text-sm"></i>
                  </div>
                </Link>
              ))}
            </div>

            <Link
              to="/category/nba"
              className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors duration-200 self-start whitespace-nowrap cursor-pointer"
            >
              更多NBA视频
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}